import { RunningExperiments, useExperiments } from 'state/experiments';

enum ComboUpsellsVariants {
  Control = 'control',
  Treatment = 'treatment',
}

export const useComboUpsellsExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ComboUpsells, ComboUpsellsVariants.Treatment);
};
